import { I18n } from "i18n-js";
import translations from "./locales.json";

const DEFAULT_LOCALE = "fr";

I18n.translations = {
  ...(I18n.translations || {}),
  ...translations,
};

I18n.defaultLocale = DEFAULT_LOCALE;
I18n.locale =
  (typeof document !== "undefined" && document.documentElement.lang) ||
  DEFAULT_LOCALE;

const i18n = new I18n(translations, {
  locale: (typeof document !== "undefined" && document.documentElement.lang) || DEFAULT_LOCALE,
  defaultLocale: (typeof document !== "undefined" && document.documentElement.lang) || DEFAULT_LOCALE,
});

export default i18n;